<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light"  id="navbar" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="/img/devconf_logo_white.png" alt="logo">
            </router-link>

            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
              <li class="nav-item">
                  <a class="nav-link nav-link-icon" v-bind:class="{ disabled: !pactive}" v-bind:href="program"
                     data-toggle="tooltip" title="Bekijk het programma">
                      <icon name="ni ni-planet" rounded ></icon>
                      <span class="nav-link-inner--text d-lg-none">Programma</span>
                  </a>
              </li>
              <li class="nav-item">
                  <a class="nav-link nav-link-icon" v-bind:class="{ disabled: !eactive}" v-bind:href="event"
                     data-toggle="tooltip" title="Open de 'Virtual Venue'">
                      <icon name="ni ni-spaceship" rounded ></icon>
                      <span class="nav-link-inner--text d-lg-none">Virtual Venue</span>
                  </a>
              </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="/archief"
                       data-toggle="tooltip" title="Bekijk voorgaande edities">
                        <icon name="ni ni-ruler-pencil" rounded ></icon>
                        <span class="nav-link-inner--text d-lg-none">Archief</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";

import CloseButton from "@/components/CloseButton";
import variables from "../variables.js";
export default {
  components: {
    BaseNav,
    CloseButton,
  },
  data(){
    return {
      pactive: false,
      eactive: false,
      program: "#",
      event: "#"
    }
  },
  mounted(){
    if (variables.getVariable("programma")){
      this.pactive = true;
      this.program = "/programma";
    }
    if (variables.getVariable("event")){
      this.eactive = true;
      this.event = variables.getVariable("event");
    }
  }
};
</script>
<style>
</style>
